import {BaseSearchRequest} from "./baseSearchRequest";
import { OrderBy } from "ngx-odata-v4";
/**
 * Created by alex.y on 9/13/2017.
 */
export class OrderSearchRequest extends BaseSearchRequest {
    public OrderBy : {PropertyName: string , OrderBy: OrderBy}

    public constructor(obj : Partial<OrderSearchRequest>){
        super();
        Object.assign(this,obj);
    }

}


// WEBPACK FOOTER //
// ./app/objects/requests/orderSearchRequest.ts